/**
 * GoPay icon URL
 * Indonesia's popular e-wallet payment method (part of Gojek ecosystem)
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const GOPAY_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/mjau5Tqscwu9tbhRLFbmJ/a66cd2894060b2d3a94b75d7f4e65355/______2022-07-04_17.05.18.png';
